import { useTranslation } from "react-i18next";

// components/WhyTrustUs.jsx
const WhyTrustUs = () => {
  const {t} = useTranslation();
    return (
      <section className="bg-gray-50 dark:bg-[#706F6F] py-20 px-4 min-h-[100vh]">
  <div className="max-w-6xl mx-auto text-center">
    <h2 className="text-4xl font-bold text-[#42AB3F] mb-4">
      {t("whyTrustUsTitle")}
    </h2>
    <p className="text-gray-600 dark:text-white mb-12 max-w-2xl mx-auto">
      {t("whyTrustUsDescription")}
    </p>

    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 text-left">
      {[
        {
          title: t("whyTrustUsTitle1"),
          description:
            t("whyTrustUsDescription1"),
        },
        {
          title: t("whyTrustUsTitle2"),
          description:
            t("whyTrustUsDescription2"),
        },
        {
          title: t("whyTrustUsTitle3"),
          description:
            t("whyTrustUsDescription3"),
        },
        {
          title: t("whyTrustUsTitle4"),
          description:
            t("whyTrustUsDescription4"),
        },
        {
          title: t("whyTrustUsTitle5"),
          description:
            t("whyTrustUsDescription5"),
        },
        {
          title: t("whyTrustUsTitle6"),
          description:
            t("whyTrustUsDescription6"),
        },
      ].map((item, index) => (
        <div
          key={index}
          className="bg-white dark:bg-white p-6 rounded-2xl shadow-md 
          transform transition-transform duration-300 hover:scale-105"
        >
          <h3 className="text-lg font-semibold text-[#DA6E2f] mb-2">
            {item.title}
          </h3>
          <p className="dark:text-black text-black">{item.description}</p>
        </div>
      ))}
    </div>
  </div>
</section>

    );
  };
  
  export default WhyTrustUs;
  